import { editorUrlConverter, sanitizeArticleLinks } from "../../../utils/editorLinks";
import {
  Button,
  Form,
  Input,
  Select,
  Tooltip,
  Popconfirm,
  DatePicker,
  Radio,
  notification,
  message,
  Switch,
  Tag,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Editor as TextEditor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import Loadingbox from "../../../component/loadingbox";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { useParams, useLocation } from "react-router-dom";
import PageHeader from "../../../component/pageHeaders";
import mic from "../../../assets/image/dots-loading.gif";
import { HiMicrophone } from "react-icons/hi";
import TextArea from "antd/es/input/TextArea";
import "../styles.css";
import Audiorecorder from "../../../component/audio-recorder/index";
import AudioUpload from "../../../assets/image/Group 269.svg";
import { uploadImageToS3 } from "../../../config/s3config/s3fileUpload";
import MediaLibrary from "../../../component/image-uploader/mediaLibrary";
// import ImagePicker from "../../../component/image-picker";
import ImagePicker from "../../../component/imagePicker";
import SocialShare from "./socialShareView";
import {
  PopulateSubCategory,
  getInitialValues,
  PreviewData,
} from "../utils/formactions";
import { CreateNews, getNewsById } from "../utils/apiRequest";
import {
  LoadCategories,
  LoadSubCategories,
  LoadTags,
} from "../../../utils/commonapis";

import { useNavigate } from "react-router-dom";

import { API } from "../../../config/API";
import MediaJoin from "../../../component/joinSocialMedia";
import axios from "../../../config/axiosInstance";
import DataUploadIMage from "../../../component/uploadeImageDetails";
import { Container, Col, Row } from "react-bootstrap";
import ImageItem from "./imageItem";
import PreviewModal from "../../../component/previewSession/preview";
import { IoCopyOutline } from "react-icons/io5";
import { HiRefresh } from "react-icons/hi";
import Analytics from "./analytics";
import { refreshNewsCache } from "../helpers/cache";
import AlsoRead from "../../../component/alsoReadModal";
import SocialEmbedModal from "../../../component/socialEmbedModal";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { articleLink } from "../../../utils/articleSlug";
dayjs.extend(utc);
dayjs.extend(timezone);

function NewForm(props: any) {
  const [form] = Form.useForm();
  const location = useLocation();
  let { id } = useParams();
  const navigate = useNavigate();

  const User = useSelector((state: any) => state.User.user);
  const Tags = useSelector((state: any) => state.Tags?.data);

  const initialized = useRef(false);
  const editing = useRef(false);
  const DraftData = useRef<any>({});
  const DraftImage = useRef<any>({});

  const [data, setData] = useState<any>();
  const [content, setContent] = useState<any>();
  const [blurb, setBlurb] = useState<any>();
  const [categories, setCategories] = useState([]);
  const [subcategoryData, setSubcategoryData] = useState([]) as any;
  const [subcategory, setSubcategory] = useState([]) as any;
  const [tags, setTags] = useState([]);
  const [tagFilter, setTagFilters] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);
  const [loading4, setLoading4] = useState(false);
  const [type, setType] = useState(null);
  const [microphone, setMicrophone] = useState(false);
  const [show, setShow] = useState(false);
  const [returnedNewsId, setReturnedNewsId] = useState() as any;
  const [permission, setPermission] = useState() as any;
  const [imageuploaddata, setImageuploaddata] = useState<any>({
    imageurl1: "",
    imageurl2: "",
    imageurl3: "",
  });
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [audio, setAudio] = useState(false);
  const [audiouploader, setAudiouploader] = useState<any>();
  const [isChecked, setIsChecked] = useState<any>();
  const [authorImg, setAuthorImg] = useState("");
  const [medialibrarymodal, setMedialibrarymodal] = useState(false);
  const [uploadImg, setUploadImg] = useState(false);
  const [UpdateuploadImgData, setUpdateUploadImgData] = useState(false);
  const [imageType, setImageType] = useState("");
  const [imageName, setImageName] = useState("");
  const [PreviewDatas, setPreviewDatas] = useState<any>();
  const [imageBase64, setImageBase64] = useState("");
  const [button, stepButton] = useState(false);
  const [alsoRead, setAlsoRead] = useState(false);
  const [socialEmbedModal, setSocialEmbedModal] = useState(false);
  const [searchingTags, setSearchingTags] = useState(false);
  const [socialshareModal, setSocialshareModal] = useState(false) as any;
  const [scheduled, setScheduled] = useState<dayjs.Dayjs | null>(
    data?.scheduled_at ? dayjs(data.scheduled_at).tz("Asia/Kolkata") : null
  );
  const [socialEmbed, setSocialEmbed] = useState<{
    embed_type?: string;
    social_embed?: string;
  }>({});

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        {
          color: ["red", "blue", "yellow"],
        },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  useEffect(() => {
    if (id !== undefined) {
      LoadDAta(id);
    }
    loadCategories();
    loadSubCategories();
  }, []);

  useEffect(() => {
    if (id) {
      LoadDAta(id);
    }
    // Initialize form with default values only for new news
    if (!id) {
      form.setFieldsValue({
        type: "draft",
        isHighPriority: false,
        Show: false,
      });
      // Initialize empty social embed for new articles
      setSocialEmbed({
        embed_type: "",
        social_embed: "",
      });
    }
  }, [id]);

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  useEffect(() => {
    return () => {
      // Cleanup TinyMCE instance on unmount
      if (window.tinymce) {
        window.tinymce.remove();
      }
    };
  }, []);

  // const handleEditorInit = (evt: any, editor: any) => {
  //   setLoading2(false);
  //   editor.on("keyup change", () => {
  //     setContent(editor.getContent());
  //     editing.current = true;
  //   });
  // };

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setLoading3(false);
    }
  };
  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const handleUrlChange = () => {
    if (!initialized.current) {
      initialized.current = true;
      if (id) {
        editStart(data, false, User?.username);
      }
      if (editing.current === true) {
        if (id === undefined) {
          saveDraft();
        }
      }
    }
  };

  window.addEventListener("popstate", handleUrlChange);

  window.addEventListener("beforeunload", (event) => {
    console.log("beforeunload = = = = >");
  });

  const LoadDAta = async (id: any) => {
    let url = API.BASE_URL + API.GET_ALLNEWS_ID + `${id}`;
    try {
      const response: any = await getNewsById(url);
      if (response) {
        setData(response?.data);
        setContent(response?.data?.body);
        setBlurb(response?.data?.title);
        let obj = {
          imageurl1: response?.data?.image ? response?.data?.image : "",
          imageurl2: response?.data?.image2 ? response.data.image2 : "",
          imageurl3: response?.data?.social_image
            ? response.data.social_image
            : "",
        };
        setImageuploaddata(obj);
        setAuthorImg(response?.data?.author_image);
        setAudiouploader(response?.data?.audio);
        DraftImage.current = obj;
        let initails: any = getInitialValues(response.data);

        setIsChecked(
          response?.data?.isHighPriority === true
            ? 1
            : response?.data?.isSecondLeads === true
            ? 2
            : 3
        );
        setPermission(response?.data?.id);
        editStart(response?.data, true, User?.username);

        // Set scheduled state from initial values (now handled by getInitialValues)
        setScheduled(initails.scheduled);

        // Set social embed data
        setSocialEmbed({
          embed_type: response?.data?.embed_type || "",
          social_embed: response?.data?.social_embed || "",
        });

        form.setFieldsValue(initails);
      } else {
        console.log("Error fetching data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const editStart = (val: any, editflag: Boolean, EditUser: any) => {
    try {
      let url = API.BASE_URL + API.ALL_NEWS + `/${id}/`;
      let body = {
        data: {
          editing_Status: editflag,
          liveEditingUser: EditUser,
        },
      };
      axios.put(url, body).then((response) => response);
    } catch (error) {
      console.log(error);
    }
  };

  const addImage = (image: any) => {
    if (window.tinymce && window.tinymce.activeEditor) {
      const editor = window.tinymce.activeEditor;
      let Moment = `${moment().format(
        "YYYY-MM-DDHH:MM:SS"
      )}.suprabhaatham-news.png`;
      let alt = image?.image_desc ? image?.image_desc : Moment;
      editor.insertContent(
        `<div style="display: inline-block; text-align: center;">
        <img src="${image?.image_url}" alt="${alt}" style="max-width: 100%; display: block; margin: 0 auto;" onload="this.parentElement.style.width = this.width + 'px';" />
        <div style="display: flex; justify-content: space-between; margin-top: 5px;">
          <div style="flex: 1; text-align: left;">${image?.image_desc}</div>
          <div style="flex: 1; text-align: right;">${image?.image_Caption}</div>
        </div>
      </div>`
      );
      setMedialibrarymodal(false);
    }
  };

  const addAlsoRead = (content: any) => {
    try {
      const styles = `background-color: transparant; border: 1px solid #a1a1a1; border-left: none; border-right: none; padding-left:20px; padding-right:20px; padding: 8px; margin-vertical: 10px; cursor: pointer;`;
      if (window.tinymce && window.tinymce.activeEditor) {
        const editor = window.tinymce.activeEditor;
        editor.insertContent(
          `<a  href="${content.link}" target="_blank">
            <button style="${styles}"><strong style="color: #3f70d1;">ALSO READ: </strong><span style="color: #000; font-weight: 700;">${content.content}</span></button>
           </a>`
        );
        stepButton(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addButtonMedia = (buttonContent: any) => {
    let color = "";
    if (buttonContent.media === "Whatsapp") {
      color = "#00e676";
    } else if (buttonContent.media === "Telegram") {
      color = "#64b5f6";
    } else {
      color = "#f50057";
    }
    const styles = `color: white; font-size: 16px;background:${color}; border:none; border-radius:25px;height:50px;text-align: center; padding-left:20px; padding-right:20px`;
    if (window.tinymce && window.tinymce.activeEditor) {
      const editor = window.tinymce.activeEditor;
      editor.insertContent(
        `<a href="${buttonContent.Link}" target="_blank"><button style="${styles}" >${buttonContent?.Text}</button></a>`
      );
      stepButton(false);
    }
  };

  const addSocialEmbed = (embedData: any) => {
    try {
      if (window.tinymce && window.tinymce.activeEditor) {
        const editor = window.tinymce.activeEditor;
        let embedContent = embedData.social_embed || "";

        // Clean and optimize the embed content based on type
        if (embedData.embed_type === "twitter") {
          embedContent = cleanTwitterEmbed(embedContent);
        } else if (embedData.embed_type === "instagram") {
          embedContent = cleanInstagramEmbed(embedContent);
        }

        // For Twitter and Instagram, use specific wrappers to preserve their structure
        if (embedData.embed_type === "twitter") {
          // Insert Twitter embed with minimal wrapper
          const twitterWrapper = `
            <div style="text-align: center; margin: 20px 0;">
              ${embedContent}
            </div>
          `;
          editor.insertContent(twitterWrapper);
        } else if (embedData.embed_type === "instagram") {
          // Insert Instagram embed with minimal wrapper
          const instagramWrapper = `
            <div style="text-align: center; margin: 20px 0;">
              ${embedContent}
            </div>
          `;
          editor.insertContent(instagramWrapper);
        } else {
          // For other social media, use the standard wrapper
          const embedWrapper = `
            <div style="margin: 20px 0; text-align: center;">
              ${embedContent}
            </div>
          `;
          editor.insertContent(embedWrapper);
        }

        setSocialEmbedModal(false);
        editing.current = true;

        // Show success message
        message.success(
          `${embedData.embed_type || "Social media"} embed added successfully!`
        );
      }
    } catch (err) {
      console.log("Error adding social embed:", err);
      message.error("Failed to add social embed. Please try again.");
    }
  };

  // Helper function to clean Twitter embed code
  const cleanTwitterEmbed = (embedCode: string) => {
    if (!embedCode) return "";

    // Remove any extra wrapper divs that might interfere
    let cleaned = embedCode.trim();

    // Ensure the blockquote has the correct class
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes('class="twitter-tweet"')
    ) {
      cleaned = cleaned.replace(
        /<blockquote([^>]*)>/,
        '<blockquote class="twitter-tweet"$1>'
      );
    }

    // Ensure Twitter script is present
    if (!cleaned.includes("platform.twitter.com/widgets.js")) {
      cleaned +=
        ' <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>';
    }

    return cleaned;
  };

  // Helper function to clean Instagram embed code
  const cleanInstagramEmbed = (embedCode: string) => {
    if (!embedCode) return "";

    // Remove any extra wrapper divs that might interfere
    let cleaned = embedCode.trim();

    // Ensure the blockquote has the correct class
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes('class="instagram-media"')
    ) {
      cleaned = cleaned.replace(
        /<blockquote([^>]*)>/,
        '<blockquote class="instagram-media"$1>'
      );
    }

    // Ensure required data-instgrm-permalink attribute exists
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes("data-instgrm-permalink")
    ) {
      // Try to extract Instagram URL from the content and add it as permalink
      const urlMatch = cleaned.match(
        /https:\/\/(?:www\.)?instagram\.com\/p\/[^\/\s"']*/
      );
      if (urlMatch) {
        cleaned = cleaned.replace(
          /<blockquote([^>]*class="instagram-media"[^>]*)>/,
          `<blockquote$1 data-instgrm-permalink="${urlMatch[0]}/" data-instgrm-version="14">`
        );
      }
    }

    // Ensure Instagram script is present
    if (!cleaned.includes("instagram.com/embed.js")) {
      cleaned += ' <script async src="//www.instagram.com/embed.js"></script>';
    }

    return cleaned;
  };

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return null;
  }
  const handleSpeechStart = () => {
    SpeechRecognition.startListening({ language: "ml-IN" });
  };

  const handleStopListening = () => {
    SpeechRecognition.stopListening();
    handleEditorChange(transcript);
  };

  const handleListening = () => {
    setMicrophone(!microphone);
    if (!microphone) {
      handleSpeechStart();
    } else {
      handleStopListening();
    }
  };
  const confirmrestart = () => {
    resetTranscript();
    setContent("");
  };

  const loadCategories = async () => {
    try {
      const res: any = await LoadCategories();
      setCategories(res?.data || []);
    } catch (error) {
      console.error("Failed to load categories:", error);
      setCategories([]);
    }
  };

  const loadSubCategories = async () => {
    try {
      const res: any = await LoadSubCategories();
      setSubcategoryData(res?.data || []);
      setSubcategory(res?.data || []);
    } catch (error) {
      console.error("Failed to load subcategories:", error);
      setSubcategoryData([]);
      setSubcategory([]);
    }
  };

  const getImageUrl = (urls: any) => {
    setImageuploaddata(urls);
    DraftImage.current = urls;
  };

  const { imageurl1, imageurl2, imageurl3 } = imageuploaddata;
  let pic1 = imageurl1;
  let pic2 = imageurl2;
  let pic3 = imageurl3;

  const handleEditorChange = (content: any) => {
    // Safety net: repair/drop hrefs that are pasted text rather than URLs.
    setContent(sanitizeArticleLinks(content));
    editing.current = true;
  };

  const addImagesToList = (data: any) => {
    try {
      let DataObj = imageuploaddata;

      if (data.type === "image1") {
        DataObj["imageurl1"] = "";
        DataObj["imageurl1"] = data?.image_url;
        DataObj["image1Value"] = "";
        DataObj["image1Value"] = data.image_desc;
        DataObj["image1Caption"] = "";
        DataObj["image1Caption"] = data.image_Caption;
      } else if (data.type === "image2") {
        DataObj["imageurl2"] = "";
        DataObj["imageurl2"] = data?.image_url;
        DataObj["image2Value"] = "";
        DataObj["image2Value"] = data.image_desc;
        DataObj["image2Caption"] = "";
        DataObj["image2Caption"] = data.image_Caption;
      } else if (data.type === "image3") {
        DataObj["imageurl3"] = "";
        DataObj["imageurl3"] = data?.image_url;
        DataObj["image3Value"] = "";
        DataObj["image3Value"] = data.image_desc;
        DataObj["image3Caption"] = "";
        DataObj["image3Caption"] = data.image_Caption;
      } else if (data.type === "authorImg") {
        setAuthorImg(data.image_url);
      }
      setImageuploaddata(DataObj);
      DraftImage.current = DataObj;
      setSocialshareModal(null);
    } catch (err) {
      console.log(err);
    }
  };

  function deleteImagesFromList(key: any) {
    try {
      setImageuploaddata((prevImages: any) => {
        const updatedImages = { ...prevImages };
        updatedImages[key] = "";
        return updatedImages;
      });
      notification.success({
        message: `Image Removed`,
      });
    } catch (err) {
      notification.error({
        message: `Failed to remove`,
      });
    }
  }

  const handleblurbEditorChange = (blurb: any, editor: any) => {
    setBlurb(blurb);
    editing.current = true;
  };

  const handleCategoriesChange = (val: any) => {
    const subCat = PopulateSubCategory(val, subcategoryData);
    setSubcategory(subCat);
  };

  const handleUrlCopy = (type: any) => {
    const perma = form.getFieldValue("permalink");
    // The canonical URL: /details/<id>/<slug> when the permalink is usable,
    // otherwise the bare URL (never `?link=undefined`).
    const link = articleLink(returnedNewsId ? returnedNewsId : data?.id, {
      permalink: perma,
    });
    if (type === "copy") {
      navigator.clipboard.writeText(link).then(() => {
        message.success("link copied");
      });
    } else if (type === "preview") {
      window.open(link, "_blank");
    }
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await form.validateFields();
      setType(values.type);

      if (values.type === "scheduled" && !scheduled) {
        message.error("Scheduled date & time is required");
        setLoading(false);
        return;
      }

      // Validate scheduled time is not in the past
      if (
        values.type === "scheduled" &&
        scheduled &&
        scheduled.isBefore(dayjs())
      ) {
        message.error("Cannot schedule for past date/time");
        setLoading(false);
        return;
      }
      let body = {
        id: data?.id || returnedNewsId,
        blurb: blurb,
        body: content,
        image: pic1,
        image2: pic2,
        onlive: data?.onlive,
        social_image: pic3,
        publishedAt:
          values.type === "publish"
            ? new Date()
            : values.type === "update"
            ? data?.publishedAt
            : null,
        audio: audiouploader ? audiouploader : null,
        user: id !== undefined ? data?.user?.id : User?.id,
        image1_description: imageuploaddata?.image1Value,
        image2_description: imageuploaddata?.image2Value,
        author_image: authorImg ? authorImg : null,
        image1_caption: imageuploaddata?.image1Caption,
        scheduled_at:
          values.type === "scheduled" && scheduled
            ? scheduled.utc().toISOString()
            : values.type === "update" && scheduled
            ? scheduled.utc().toISOString()
            : values.type === "save" && scheduled
            ? scheduled.utc().toISOString()
            : null,
        social_embed: socialEmbed.social_embed || null,
        embed_type: socialEmbed.embed_type || null,
      };

      // Debug: Log the social embed data being sent
      console.log("Social Embed Data:", {
        social_embed: socialEmbed.social_embed,
        embed_type: socialEmbed.embed_type,
        socialEmbedState: socialEmbed,
      });

      const res: any = await CreateNews(values, body, User?.id);
      if (res.id) {
        editing.current = false;
        setReturnedNewsId(res?.id);
        if (body?.id) {
          refreshNewsCache(id);
        }
        setTimeout(() => {
          window.location.replace(`/Auth/home/news/${res.id}`);
          // navigate(`/Auth/home/news/${res.id}`);
        }, 200);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to validate:", error);
    }
  };

  const onchangeData = (body: any, allValues: any) => {
    editing.current = true;
    const tagsfilteredArray = allValues?.tags ? allValues.tags.join("|") : "";
    var obj = {
      title: blurb || "",
      head: allValues?.head || "",
      author_image: allValues?.author_image || "",
      author_name: allValues?.author_name || "",
      categories:
        allValues?.categories?.map((item: any) => {
          let cat = JSON.parse(item);
          let id = cat.id;
          return id;
        }) || [],
      user: User?.id,
      isHighPriority: allValues?.isHighPriority || false,
      permalink: allValues?.permalink || "",
      publish_time: allValues?.publish_time || "",
      subcategory:
        allValues?.subcategory?.map((item: any) => {
          let cat = JSON.parse(item);
          return cat;
        }) || [],
      newsTag: tagsfilteredArray,
      body: content,
      scheduled_at: allValues?.scheduled
        ? allValues.scheduled.utc().toISOString()
        : null,
      social_embed: socialEmbed.social_embed || null,
      embed_type: socialEmbed.embed_type || null,
    };
    if (allValues) {
      DraftData.current = obj;
    }
  };

  const saveDraft = async () => {
    try {
      if (DraftData) {
        let url = API.BASE_URL + API.CREATENEWS;
        let obj = {
          data: {
            author_image: DraftData?.current?.author_image,
            author_name: DraftData?.current?.author_name,
            body: DraftData?.current?.body,
            categories: DraftData?.current?.categories,
            head: DraftData?.current?.head,
            image: DraftImage?.current?.imageurl1,
            image2: DraftImage?.current?.imageurl2,
            isHighPriority: DraftData?.current?.isHighPriority,
            permalink: DraftData?.current?.permalink,
            social_image: DraftImage?.current?.imageurl3,
            Subcategories: DraftData?.current?.subcategory,
            newsTag: DraftData?.current?.newsTag,
            title: DraftData?.current?.blurb,
            user: DraftData?.current?.user,
            image1_description: imageuploaddata?.image1Value,
            image1_caption: imageuploaddata?.image1Caption,
            image2_description: imageuploaddata?.image2Value,
            scheduled_at: DraftData?.current?.scheduled_at,
            social_embed: DraftData?.current?.social_embed,
            embed_type: DraftData?.current?.embed_type,
          },
        };
        axios.post(url, obj).then((response) => response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addNew = () => {
    window.location.replace(`/Auth/home/news`);
  };

  const previewData = () => {
    let body = {
      items: data,
      titleValue: blurb,
      body: content,
      tags: tags,
      pic1: pic1,
      imageBase64: imageBase64,
    };
    const Data = PreviewData(form, body);
    setPreviewDatas(Data);
    setShow(true);
  };

  const checkPermaLink = (e: any) => {
    const regex = /^[a-zA-Z0-9- ]*$/;
    const inputValue = e.target.value;
    const filteredValue = inputValue
      .split("")
      .filter((char: any) => regex.test(char))
      .join("");
    form.setFieldsValue({ permalink: filteredValue });
  };

  return (
    <div style={{ height: "90vh", overflowY: "scroll" }}>
      <PageHeader
        title={`${id !== null && id !== undefined ? "Edit" : "Create"} News`}
      >
        <div className="homescreen-pageItem">
          {id !== null && id !== undefined ? (
            <Tag
              style={{ padding: 5, paddingLeft: 20, paddingRight: 20 }}
              color={
                data?.publishedAt
                  ? "green"
                  : data?.scheduled_at
                  ? "pink"
                  : "blue"
              }
            >
              {data?.publishedAt
                ? "Published"
                : data?.scheduled_at
                ? "Scheduled"
                : "Draft"}
            </Tag>
          ) : null}
          <Button onClick={previewData} disabled={data && !data.id}>
            Preview
          </Button>
          &nbsp;
          <Button icon={<HiRefresh />} onClick={() => refreshNewsCache(id)}>
            Cache
          </Button>
          {id !== null && id !== undefined ? (
            <div>
              <Button
                onClick={() => handleUrlCopy("preview")}
                disabled={data && !data.id}
              >
                Website Preview
              </Button>
              &nbsp;
              <Button type="primary" onClick={addNew}>
                Create New +
              </Button>
            </div>
          ) : null}
        </div>
      </PageHeader>
      <Form
        form={form}
        onFinish={onFinish}
        onValuesChange={onchangeData}
        name="add-news"
        scrollToFirstError
      >
        <Container fluid>
          <Row>
            <Col sm={9} xs={12}>
              <label className="newsFormLabels">Heading</label>
              <Form.Item name="head">
                <TextArea />
              </Form.Item>
              {loading2 && <Loadingbox />}
              <div className="homescreen-pageBox2">
                <div style={{ flex: 1 }}>
                  <label className="newsFormLabels">News Body</label>
                </div>
                <Tooltip title={"Start / Stop Listening"}>
                  <Button onClick={handleListening} size="small">
                    {microphone ? (
                      <img src={mic} style={{ width: 10 }} />
                    ) : (
                      <HiMicrophone size={15} />
                    )}
                  </Button>
                </Tooltip>
                &nbsp;
                <Popconfirm
                  title="reset"
                  description="Are you sure to reset ?"
                  onConfirm={confirmrestart}
                >
                  <Button size="small">reset</Button>
                </Popconfirm>
              </div>
              <input
                id="my-file"
                type="file"
                name="my-file"
                style={{ display: "none" }}
              />
              {loading4 && (
                <div className="homescreen-loading-indicator">Uploading...</div>
              )}
              <TextEditor
                //  apiKey={API.EDITOR_API_KEY}
                value={content}
                init={{
                  height: 500,
                  menubar: true,
                  directionality: "ltr",
                  // Keep URLs exactly as entered and repair pasted "headline + URL" strings
                  // (see src/utils/editorLinks.ts).
                  convert_urls: false,
                  urlconverter_callback: editorUrlConverter,
                  plugins:
                    "advlist autolink lists link image pageembed code preview charmap print preview anchor help searchreplace visualblocks code insertdatetime media table paste wordcount pageembed code preview image code",
                  toolbar1:
                    "  | bold italic | \
                    alignleft aligncenter alignright | \
                    bullist numlist outdent indent |subscript superscript |link unlink | forecolor backcolor | \
                    \
                    \
                    \
                    | image | myCustomButton | help | ",

                  // toolbar1:
                  //   "bold italic underline | alignleft aligncenter alignright | link unlink | myCustomButton joinButton",
                  toolbar2: "joinButton | alsoRead | socialEmbed ",
                  setup: (editor) => {
                    editor.ui.registry.addButton("myCustomButton", {
                      text: "Media Library",
                      icon: "gallery",
                      onAction: () => {
                        setImageType("Media");
                        setUploadImg(true);
                      },
                    });
                    editor.ui.registry.addButton("joinButton", {
                      text: "Custom Button",
                      onAction: () => {
                        stepButton(true);
                      },
                    });
                    editor.ui.registry.addButton("alsoRead", {
                      text: "Add Also Read",
                      onAction: () => {
                        setAlsoRead(true);
                      },
                    });
                    editor.ui.registry.addButton("socialEmbed", {
                      text: "Social Embed",
                      onAction: () => {
                        setSocialEmbedModal(true);
                      },
                    });
                  },

                  file_browser_callback_types: "image media",
                  file_picker_callback: function (callback, value, meta) {
                    if (
                      meta.filetype === "image" ||
                      meta.filetype === "media"
                    ) {
                      var input = document.getElementById("my-file") as any;
                      input.click();
                      input.onchange = async function () {
                        const name = input?.files[0]?.name;
                        const sliced = name?.slice(0, name.length - 5);
                        var file = input?.files[0];
                        let filetype = file?.type?.split("/")[1];
                        setLoading4(true);

                        await uploadImageToS3(file)
                          .then((s3ImageUrl: any) => {
                            callback(s3ImageUrl?.data?.imageUrl, {
                              alt: file.name,
                            });
                          })
                          .catch((error) => {
                            console.error(
                              "Error uploading image to S3:",
                              error
                            );
                          })
                          .finally(() => {
                            setLoading4(false);
                          });
                      };
                    }
                  },
                  paste_data_images: false,
                }}
                onEditorChange={handleEditorChange}
                onInit={() => setLoading2(false)}
              />
              <Row>
                <Col md={6}>
                  <label className="newsFormLabels">Categories <span style={{ color: "red" }}>*</span></label>
                  <Form.Item
                    name="categories"
                    rules={[
                      {
                        required: true,
                        message: "Please select Categories!",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      mode="multiple"
                      onChange={handleCategoriesChange}
                    >
                      {categories?.length > 0 &&
                        categories.map((item: any, index: any) => {
                          let obj = {
                            id: item.id,
                            category: item.attributes.category,
                          };
                          let category = JSON.stringify(obj);
                          return (
                            <Select.Option key={index} value={category}>
                              {item?.attributes?.category}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  <label className="newsFormLabels">Tags <span style={{ color: "red" }}>*</span></label>
                  <Form.Item
                    name="tags"
                    rules={[
                      {
                        required: true,
                        message: "Please select at least one tag",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      mode="tags"
                      style={{ background: "transparent" }}
                      loading={loading3 || searchingTags}
                      showSearch
                      placeholder="Search for tags"
                      onSearch={(val) => OnTagSearch(val)}
                      filterOption={false}
                    >
                      {tags?.length &&
                        tags.map((item: any, index: any) => {
                          let tag = item.tag;
                          return (
                            <Select.Option key={index} value={tag}>
                              {item.tag}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6}>
                  <label className="newsFormLabels">Sub-Category <span style={{ color: "red" }}>*</span></label>
                  <Form.Item
                    name="subcategory"
                    rules={[
                      {
                        required: true,
                        message: "Please select subcategory!",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      mode="multiple"
                      showSearch
                      filterOption={(input: any, option: any) =>
                        option?.children
                          ?.toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {subcategory.map((item: any, index: any) => {
                        return (
                          <Select.Option key={index} value={item.id}>
                            {item.attributes.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <label className="newsFormLabels">Blurb</label>
              <ReactQuill
                style={{ height: "150px" }}
                theme="snow"
                value={blurb}
                onChange={handleblurbEditorChange}
                modules={modules}
              />
              <br />
              <br />
              <Row>
                <Col sm={4}>
                  <div className="newsFormLabels">News Image 1</div>
                  <ImageItem
                    imageurl={imageuploaddata?.imageurl1}
                    upload={() => {
                      if (imageuploaddata?.imageurl1 === "") {
                        setImageType("image1");
                        setImageName("Image 1");
                        setUploadImg(true);
                        editing.current = true;
                      }
                    }}
                    delete={() => deleteImagesFromList("imageurl1")}
                  />
                </Col>
                <Col sm={4}>
                  <div className="newsFormLabels">News Image 2</div>
                  <ImageItem
                    imageurl={imageuploaddata?.imageurl2}
                    upload={() => {
                      if (imageuploaddata?.imageurl2 === "") {
                        setImageType("image2");
                        setImageName("Image 2");
                        setUploadImg(true);
                        editing.current = true;
                      }
                    }}
                    delete={() => {
                      imageuploaddata["imageurl2"] = "";
                      deleteImagesFromList("imageurl2");
                    }}
                  />
                </Col>
                <Col sm={4}>
                  <div className="newsFormLabels">Social Media Image</div>
                  <ImageItem
                    imageurl={imageuploaddata?.imageurl3}
                    upload={() => {
                      if (imageuploaddata?.imageurl3 === "") {
                        setImageType("image3");
                        setImageName("Social Media Image");
                        setUploadImg(true);
                        editing.current = true;
                      }
                    }}
                    delete={() => deleteImagesFromList("imageurl3")}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col sm={8}></Col>
                <Col sm={4}>
                  <div className="newsFormLabels">Audio News Recorder</div>
                  <div
                    className="homeScrn-pickerIcon"
                    onClick={() => {
                      setAudio(true);
                      editing.current = true;
                    }}
                  >
                    <img alt="img" src={AudioUpload} />
                    <div className="homeScrn-Uploadtxt ">
                      Cick here to record
                    </div>
                  </div>
                  {audiouploader ? (
                    <audio
                      style={{ width: "100%" }}
                      src={audiouploader}
                      controls
                    />
                  ) : null}
                </Col>
              </Row>
              <hr />
              <Row>
                <Col sm="3" />
                <Col sm="3">
                  {id ? (
                    <Button
                      size="large"
                      block
                      loading={type === "update" && loading}
                      style={{ height: 50 }}
                      onClick={() => {
                        let values: any = form.getFieldsValue();
                        values["type"] = "update";
                        onFinish(values);
                      }}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      size="large"
                      block
                      style={{ height: 50 }}
                      loading={type === "save" && loading}
                      onClick={() => {
                        let values: any = form.getFieldsValue();
                        values["type"] = "save";
                        onFinish(values);
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Col>
                <Col sm="3">
                  <Button
                    loading={type === "scheduled" && loading}
                    size="large"
                    block
                    style={{ height: 50, backgroundColor: "#d6d6d6ff" }}
                    disabled={!!(data?.scheduled_at || data?.publishedAt)}
                    onClick={() => {
                      let values: any = form.getFieldsValue();
                      values["type"] = "scheduled";
                      onFinish(values);
                    }}
                  >
                    Schedule
                  </Button>
                </Col>
                <Col sm="3">
                  <Button
                    type="primary"
                    loading={type === "publish" && loading}
                    size="large"
                    block
                    style={{ height: 50 }}
                    disabled={!!(data?.scheduled_at || data?.publishedAt)}
                    onClick={() => {
                      let values: any = form.getFieldsValue();
                      values["type"] = "publish";
                      onFinish(values);
                    }}
                  >
                    Publish
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col sm={3} xs={12}>
              <div className="newsFormBox">
                <div className="homescreen-pageBox2">
                  <div className="newsFormLabels" style={{ flex: 1 }}>
                    Perma-Link
                  </div>
                  <div>
                    {returnedNewsId || data?.id ? (
                      <IoCopyOutline
                        size={18}
                        color="green"
                        onClick={() => handleUrlCopy("copy")}
                        style={{ cursor: "pointer" }}
                      />
                    ) : null}
                  </div>
                </div>
                <Form.Item
                  name="permalink"
                  rules={[
                    {
                      validator: (_, value) => {
                        const regex = /^[a-zA-Z0-9- ]*$/;
                        return regex.test(value)
                          ? Promise.resolve()
                          : Promise.reject(
                              "Only alphanumeric characters, spaces, and dashes are allowed."
                            );
                      },
                    },
                  ]}
                >
                  <Input.TextArea
                    size="large"
                    lang="en"
                    onChange={checkPermaLink}
                  />
                </Form.Item>
                <div className="newsFormLabels">Priority</div>
                <Form.Item name="isHighPriority">
                  <Radio.Group
                    className="square-radio-button"
                    defaultValue={isChecked}
                    size="large"
                  >
                    <Radio value={1}>First leads</Radio>
                    <Radio value={2}>Second leads</Radio>
                    <Radio value={3}>No leads</Radio>
                  </Radio.Group>
                </Form.Item>
                <label className="newsFormLabels">on Live</label>
                <Form.Item name="Show">
                  <Switch
                    defaultChecked={
                      location?.state?.item === true ? true : false
                    }
                  />
                </Form.Item>
                <div className="newsFormLabels">Byline</div>
                <Form.Item name="author_name">
                  <Input size="large" />
                </Form.Item>
                <div className="newsFormLabels">Author Image</div>
                <ImageItem
                  imageurl={authorImg}
                  upload={() => {
                    setImageType("authorImg");
                    setUploadImg(true);
                    editing.current = true;
                  }}
                  delete={() => setAuthorImg("")}
                />
                <br />
                <div className="newsFormLabels">Scheduled</div>
                <Form.Item name="scheduled">
                  <DatePicker
                    showTime={{
                      use12Hours: true,
                      format: "h:mm A",
                      minuteStep: 1,
                    }}
                    format="DD-MM-YYYY h:mm A"
                    placeholder="Select scheduled date and time"
                    size="large"
                    style={{ width: "100%" }}
                    value={scheduled}
                    onChange={(value: any) => {
                      if (value) {
                        // Ensure the time is in IST
                        const istTime = value.tz("Asia/Kolkata");
                        setScheduled(istTime);
                      } else {
                        setScheduled(null);
                      }
                    }}
                    showNow={true}
                    disabledDate={(current: any) => {
                      // Optionally disable past dates
                      // return current && current < dayjs().startOf('day');
                      return false; // Allow all dates
                    }}
                  />
                </Form.Item>
                {User.role.id === 4 ? (
                  <Col md={24}>
                    <div className="newsFormLabels">Author</div>
                    <Form.Item name="user_id">
                      <Input disabled defaultValue={User.username} />
                    </Form.Item>
                  </Col>
                ) : null}
                <Button
                  block
                  onClick={() => setSocialshareModal(true)}
                  disabled={data && !data.id}
                  type="primary"
                  size="large"
                >
                  Social Share Preview
                </Button>

                <br />
                {data && data.id ? <Analytics data={data} /> : null}
              </div>
            </Col>
          </Row>
        </Container>
      </Form>
      <br />
      {audio ? (
        <Audiorecorder
          getData={(data: any) => {
            setAudiouploader(data);
          }}
          visible={audio}
          close={() => setAudio(false)}
        />
      ) : null}
      {show ? (
        <PreviewModal
          open={show}
          footer={false}
          onCancel={() => setShow(false)}
          preview={() => handleUrlCopy("preview")}
          data={PreviewDatas}
        />
      ) : null}
      {medialibrarymodal ? (
        <MediaLibrary
          visible={medialibrarymodal}
          onSelect={addImage}
          onCancel={() => setMedialibrarymodal(false)}
        />
      ) : null}
      <ImagePicker
        mode="create"
        imageType={imageType}
        imageName={imageName}
        onSelect={(media: any) => addImage(media)}
        onSubmit={(val: any) => addImagesToList(val)}
        visible={uploadImg}
        close={() => setUploadImg(false)}
      />
      <DataUploadIMage
        mode="update"
        imageType={imageType}
        data={data}
        onSelect={addImage}
        onSubmit={(val: any) => addImagesToList(val)}
        visible={UpdateuploadImgData}
        close={() => setUpdateUploadImgData(false)}
      />
      {socialshareModal ? (
        <SocialShare
          image={imageuploaddata?.imageurl3 || imageuploaddata.imageurl1}
          data={data}
          visible={socialshareModal}
          onCancel={() => setSocialshareModal(false)}
        />
      ) : null}

      {alsoRead ? (
        <AlsoRead
          visible={alsoRead}
          close={() => setAlsoRead(false)}
          onSubmit={(val: any) => addAlsoRead(val)}
        />
      ) : null}
      {button ? (
        <MediaJoin
          onSubmit={(val: any) => addButtonMedia(val)}
          visible={button}
          close={() => stepButton(false)}
        />
      ) : null}
      {socialEmbedModal ? (
        <SocialEmbedModal
          visible={socialEmbedModal}
          onCancel={() => setSocialEmbedModal(false)}
          onSubmit={(val: any) => addSocialEmbed(val)}
          initialValue={socialEmbed}
        />
      ) : null}
      <br />
    </div>
  );
}
export default NewForm;
